{
  "Required": "Campo obligatorio",
  "ValidatingPassword": "La contraseña debe contener 6 caracteres como mínimo",
  "PasswordDoesNotMatch": "Las contraseñas no coinciden",

  "ResetYourPassword": "Restablecer tu contraseña",
  "Password": "Contraseña",
  "ConfirmPassword": "Confirmar contraseña",
  "ResetButton": "Reiniciar >",
  "Login": "Iniciar sesión",
  "or": "o",
  "Signup": "Regístrate",
  "instead": "en lugar"
}
